import type { DialogConf } from '@Primitive/ExDialog';
import type { SettingsToolbarSettings } from '@Primitive/SettingsList';
import { isDefined } from '@Utils/Micro';
// ------------------------------------------------------------------------------------------------
export interface IWidgetDialog {
    show: (dialogInfo: DialogConf) => void;
    close: () => void;
    error: (error: string) => void;
}
// ------------------------------------------------------------------------------------------------
export class IWidgetClassParent {

    /**
     * Whether Parent supports edit mode or not
     */
    public get SupportEditing(): boolean { return this._supportEditing; }
    private _supportEditing: boolean;

    /**
     *
     */
    public get DialogConf(): IWidgetDialog { return this._dialogConf; }
    private _dialogConf: IWidgetDialog;

    public get SettingsListToolbar(): SettingsToolbarSettings { return this._settingsListToolbar; }
    private _settingsListToolbar: SettingsToolbarSettings;
    // --------------------------------------------------------------------------------------------
    private _CheckForUpdatedData: (Key: string, NewWidgetData: any) => void;
    private _inEditMode: () => boolean;
    private _inDebug: () => boolean;
    // --------------------------------------------------------------------------------------------
    constructor(
        _CheckForUpdatedData: (Key: string, NewWidgetData: any) => void,
        _inEditMode: () => boolean,
        _supportEditing: boolean = false,
        _inDebug: () => boolean = null,
        _dialogConf: IWidgetDialog = null,
        _settingsListToolbar: SettingsToolbarSettings = null
    ) {
        this._CheckForUpdatedData = _CheckForUpdatedData;
        this._inEditMode = _inEditMode;
        this._supportEditing = _supportEditing;
        this._inDebug = _inDebug;
        this._dialogConf = isDefined(_dialogConf) ? _dialogConf : {
            show: (dialogInfo: DialogConf) => { },
            close: () => { },
            error: (error: string) => { }
        };
        this._settingsListToolbar = _settingsListToolbar;
    }
    // --------------------------------------------------------------------------------------------
    /**
     * Called when widget get new data.
     * @param  {string} key Widget's key
     * @param  {any} newWidgetData Widget's new data.
     * @returns void
     */
    public CheckForUpdatedData(key: string, newWidgetData: any) {
        if (isDefined(this._CheckForUpdatedData))
            this._CheckForUpdatedData(key, newWidgetData);
    }
    // --------------------------------------------------------------------------------------------
    /**
     * User for defining if widget is in edit mode or not
     * @returns boolean
     */
    public inEditMode(): boolean {
        if (isDefined(this._inEditMode))
            return this._inEditMode();
        return false;
    }

    /**
     * Whether Parent wants debug enabled or not.
     * @returns boolean
     */
    public inDebug(): boolean {
        if (isDefined(this._inDebug))
            return this._inDebug();
        return false;
    }
    // --------------------------------------------------------------------------------------------
}